import styled from 'styled-components';

const ImageContainer = styled.div`
  height: auto;
  max-width: 400px;
  margin: auto;
`;

const Image = styled.img`
  width: 100%;
  height: auto;
`;

export { ImageContainer, Image };
